import parse from "html-react-parser"

export default function MoreInformation( props ) {
	const c = props.cruise
	return <>
	    { parse( c.information || '' ) }
	</>
}
